import { FoodOption, OrderOption } from 'earn-ts/build/rust';
import { useTranslation } from 'react-i18next';
import SquareRadio from '../Square-radio';

interface IPageHeader {
  title: string;
  description?: string;
  listGroupRadio: { [key: string]: FoodOption };
  handleChange: (optionGroup: string, option: string) => void;
  dataGroupSelected: OrderOption;
  required: boolean;
  disable: boolean;
  optionGroupKey: string
}

const OptionGroup = ({
  title,
  description,
  listGroupRadio,
  handleChange,
  dataGroupSelected,
  disable,
  required,
  optionGroupKey
}: IPageHeader) => {
  const { t } = useTranslation(['main']);
  return (
    <div className={`w-full flex flex-col mt-3 ${disable && 'hidden'}`}>
      <div className="text-[16px] capitalize text-left">{title}</div>
      <div className="text-[16px] text-shadow-5 text-left mb-1">{description}</div>
      <div className={`px-4 py-[2px] w-fit text-[12px] ${required ? 'bg-background-error text-error' : 'bg-background-success text-success'}`}>{required ? t('Required') : t('Optional')}</div>
      <div className="flex flex-wrap mt-4">
        {Object.keys(listGroupRadio).map((item, index) => (
          <SquareRadio
            value={listGroupRadio[item].name_en || ''}
            name={title}
            id={item}
            key={index}
            optionGroupKey= {optionGroupKey}
            handleChange={handleChange}
            valueSelected={dataGroupSelected ? dataGroupSelected?.flags : []}
          />
        ))}
      </div>
    </div>
  );
};

export default OptionGroup;
